<template>
  <div class="occurrence-page">
    <!-- Mapa fullscreen -->
    <GmapMap
      ref="mapRef"
      :center="mapCenter"
      :zoom="13"
      map-type-id="roadmap"
      style="width: 100%; height: 100%"
      @click="onMapClick"
    >
      <GmapMarker
        v-for="occ in mapOccurrences"
        :key="'occ-' + occ.id"
        :position="{ lat: occ.latitude, lng: occ.longitude }"
        :title="occ.requester_name"
        :icon="getMarkerIcon(occ)"
        @click="
          selectedMapOcc = occ;
          showInfoWindow = true;
          infoWindowPos = { lat: occ.latitude, lng: occ.longitude };
        "
      />
      <GmapMarker
        v-if="form.latitude && form.longitude"
        :position="{
          lat: parseFloat(form.latitude),
          lng: parseFloat(form.longitude),
        }"
        :draggable="true"
        @dragend="onMarkerDrag"
      />
      <GmapInfoWindow
        :options="{ maxWidth: 340 }"
        :position="infoWindowPos"
        :opened="showInfoWindow"
        @closeclick="showInfoWindow = false"
      >
        <div
          v-if="selectedMapOcc"
          style="font-size: 13px; min-width: 280px; line-height: 1.6"
        >
          <!-- Cabeçalho -->
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 6px;
            "
          >
            <strong style="font-size: 14px">{{
              selectedMapOcc.requester_name
            }}</strong>
            <span
              :style="{
                display: 'inline-block',
                padding: '1px 8px',
                borderRadius: '12px',
                fontSize: '11px',
                fontWeight: 'bold',
                background: selectedMapOcc.status == 1 ? '#d4edda' : '#f8d7da',
                color: selectedMapOcc.status == 1 ? '#155724' : '#721c24',
              }"
            >{{ selectedMapOcc.status == 1 ? "Aberta" : "Fechada" }}</span>
          </div>

          <!-- Protocolo e tempo -->
          <div style="color: #666; font-size: 11px; margin-bottom: 6px">
            <span
              v-if="selectedMapOcc.protocol"
            >#{{ selectedMapOcc.protocol }} &bull;
            </span>
            Aberta {{ timeAgo(selectedMapOcc.created_at) }}
          </div>

          <hr style="margin: 4px 0 6px; border-color: #eee">

          <!-- Endereço -->
          <div
            v-if="selectedMapOcc.address"
            style="margin-bottom: 4px"
          >
            <b>Endereço:</b>
            {{ selectedMapOcc.address
            }}{{ selectedMapOcc.number ? ", " + selectedMapOcc.number : ""
            }}{{
              selectedMapOcc.complement
                ? " - " + selectedMapOcc.complement
                : ""
            }}<br>
            <span
              v-if="selectedMapOcc.neighborhood"
              style="color: #555"
            >
              {{ selectedMapOcc.neighborhood
              }}{{ selectedMapOcc.city ? " - " + selectedMapOcc.city : ""
              }}{{ selectedMapOcc.state ? "/" + selectedMapOcc.state : "" }}
            </span>
          </div>

          <!-- Telefone -->
          <div
            v-if="selectedMapOcc.requester_phone"
            style="margin-bottom: 4px"
          >
            <b>Telefone:</b> {{ selectedMapOcc.requester_phone }}
          </div>

          <hr style="margin: 4px 0 6px; border-color: #eee">

          <!-- Disciplina / Tipo / Motivo -->
          <div
            v-if="selectedMapOcc.discipline"
            style="margin-bottom: 2px"
          >
            <b>Disciplina:</b> {{ selectedMapOcc.discipline }}
          </div>
          <div
            v-if="selectedMapOcc.dispatch_type"
            style="margin-bottom: 2px"
          >
            <b>Tipo:</b> {{ selectedMapOcc.dispatch_type }}
          </div>
          <div
            v-if="selectedMapOcc.dispatch_reason"
            style="margin-bottom: 2px"
          >
            <b>Motivo:</b> {{ selectedMapOcc.dispatch_reason }}
          </div>

          <!-- Queixa -->
          <div
            v-if="selectedMapOcc.complaint"
            style="
              margin-top: 6px;
              padding: 5px 7px;
              background: #f8f9fa;
              border-radius: 4px;
              font-style: italic;
              color: #444;
            "
          >
            "{{ selectedMapOcc.complaint }}"
          </div>

          <!-- Quem abriu -->
          <div
            v-if="selectedMapOcc.created_by"
            style="margin-top: 6px; color: #888; font-size: 11px"
          >
            Aberta por: {{ selectedMapOcc.created_by }}
          </div>
        </div>
      </GmapInfoWindow>
    </GmapMap>

    <!-- Painel flutuante esquerdo -->
    <div class="occ-panel">
      <div class="occ-panel__header">
        <span
          v-if="creatingOccurrence"
          class="occ-panel__title occ-panel__title--creating"
        >
          <feather-icon
            icon="LoaderIcon"
            size="15"
            class="mr-25"
          />
          Abrindo ocorrência...
        </span>
        <div
          v-else-if="phoneCreateError"
          class="occ-open-error"
        >
          <span class="occ-open-error__msg">
            <feather-icon
              icon="AlertTriangleIcon"
              size="14"
              class="mr-25"
            />
            Falha ao abrir ocorrência
          </span>
          <button
            type="button"
            class="occ-open-error__retry"
            @click="retryOpenOccurrence"
          >
            <feather-icon
              icon="RefreshCwIcon"
              size="12"
              class="mr-25"
            /> Tentar
            novamente
          </button>
        </div>
        <span
          v-else-if="currentProtocol"
          class="occ-panel__title occ-panel__title--open"
        >
          <feather-icon
            icon="AlertCircleIcon"
            size="15"
            class="mr-25"
          />
          Ocorrência #{{ currentProtocol }}
          <span
            v-if="currentOccurrenceCreatedAt"
            :class="[elapsedBadgeClass(currentOccurrenceCreatedAt), 'ml-1']"
            style="font-size: 0.78em; vertical-align: middle"
          >
            {{ elapsedHHMMSS(currentOccurrenceCreatedAt) }}
          </span>
        </span>
        <h5
          v-else
          class="mb-0"
        >
          Nova Ocorrência
        </h5>
      </div>
      <div class="occ-panel__body">
        <div class="form-group">
          <label><span class="required">*</span> Telefone</label>
          <input
            v-model="form.requester_phone"
            v-mask="['(##) ####-####', '(##) #####-####']"
            type="text"
            :class="[
              'form-control',
              errors.requester_phone ? 'is-invalid' : '',
            ]"
            placeholder="(00) 00000-0000"
            @blur="onPhoneBlur"
          >
        </div>

        <div class="form-group">
          <label><span class="required">*</span> Nome do Solicitante</label>
          <input
            v-model="form.requester_name"
            type="text"
            :class="['form-control', errors.requester_name ? 'is-invalid' : '']"
            placeholder="Nome completo"
          >
        </div>

        <div class="form-group">
          <label><span class="required">*</span> Endereço</label>
          <GmapAutocomplete
            ref="autocomplete"
            :class="['form-control', errors.address ? 'is-invalid' : '']"
            placeholder="Digite o endereço..."
            @place_changed="onPlaceChanged"
          />
        </div>

        <div class="form-group">
          <label><span class="required">*</span> Queixa</label>
          <textarea
            v-model="form.complaint"
            :class="['form-control', errors.complaint ? 'is-invalid' : '']"
            rows="3"
            placeholder="Descreva a queixa relatada pelo solicitante..."
          />
        </div>

        <div class="form-group">
          <label><span class="required">*</span> Disciplina</label>
          <div :class="errors.discipline_id ? 'is-invalid-vselect' : ''">
            <v-select
              v-model="form.discipline_id"
              :options="disciplines"
              :reduce="(d) => d.id"
              label="name"
              placeholder="Selecione a disciplina..."
              class="vselect"
              @input="onDisciplineChange"
            />
          </div>
        </div>

        <div class="form-group">
          <label><span class="required">*</span> Tipo da Ocorrência</label>
          <div :class="errors.dispatch_type_id ? 'is-invalid-vselect' : ''">
            <v-select
              v-model="form.dispatch_type_id"
              :options="dispatchTypes"
              :reduce="(d) => d.id"
              label="name"
              placeholder="Selecione..."
              class="vselect"
              :disabled="!form.discipline_id"
              @input="onTypeChange"
            />
          </div>
        </div>

        <div class="form-group">
          <label>Motivo</label>
          <v-select
            ref="reasonSelect"
            v-model="form.dispatch_reason_id"
            :options="dispatchReasons"
            :reduce="(d) => d.id"
            label="name"
            placeholder="Selecione o motivo..."
            class="vselect"
            :disabled="!form.dispatch_type_id"
            @input="onReasonChange"
          />
        </div>

        <!-- Botão: responder interrogatório pendente -->
        <div
          v-if="pendingInterrogatory && interrReviewAnswers.length === 0"
          class="mb-2"
        >
          <button
            type="button"
            :class="[
              'btn btn-block',
              pendingInterrogatoryRequired
                ? 'btn-danger'
                : 'btn-outline-secondary',
            ]"
            @click="showInterrogatoryModal = true"
          >
            <feather-icon
              icon="ClipboardIcon"
              size="14"
              class="mr-50"
            />
            {{
              pendingInterrogatoryRequired
                ? "Responder Interrogatório (Obrigatório)"
                : "Responder Interrogatório (Opcional)"
            }}
          </button>
        </div>

        <!-- Alerta: interrogatório respondido -->
        <div
          v-if="interrReviewAnswers.length > 0"
          class="interr-done-row mb-2"
        >
          <span class="interr-done-label">
            <feather-icon
              icon="CheckCircleIcon"
              size="14"
              class="mr-25"
            />
            Interrogatório respondido
          </span>
          <button
            type="button"
            class="interr-done-btn"
            @click="openInterrReview"
          >
            <feather-icon
              icon="EyeIcon"
              size="13"
              class="mr-25"
            /> Revisar
          </button>
        </div>

        <div class="mb-1">
          <button
            type="button"
            class="btn btn-outline-secondary btn-block"
            :disabled="!form.discipline_id"
            :title="!form.discipline_id ? 'Selecione a disciplina primeiro' : ''"
            @click="showInvolvedModal = true"
          >
            <feather-icon
              icon="UsersIcon"
              size="14"
              class="mr-25"
            />
            {{ pendingInvolveds.length }} Envolvido(s) vinculado(s)
          </button>
          <small
            v-if="!form.discipline_id"
            class="text-muted d-block mt-25"
          >
            Selecione a disciplina para vincular envolvidos.
          </small>
        </div>

        <div
          v-if="currentOccurrenceId && $hasAbility('ocorrencia.finalizar')"
          class="mb-1"
        >
          <button
            type="button"
            class="btn btn-outline-danger btn-block"
            @click="showFinalizeModal = true"
          >
            <feather-icon
              icon="CheckCircleIcon"
              size="14"
              class="mr-25"
            />
            Finalizar ocorrência
          </button>
        </div>

        <div
          v-if="$hasAbility('ocorrencia.criar')"
          class="text-right"
        >
          <button
            class="btn btn-primary btn-block"
            @click="save"
          >
            <feather-icon
              icon="SendIcon"
              size="14"
              class="mr-25"
            /> Encaminhar
            Ocorrência
          </button>
        </div>
      </div>
    </div>

    <!-- Botão flutuante centralizado no mapa -->
    <button
      v-if="$hasAbility('ocorrencia.ver')"
      class="occ-list-fab"
      @click="showListModal = true"
    >
      <i class="fa fa-list mr-1" /> Ver Ocorrências
    </button>

    <!-- Modal de Envolvidos -->
    <OccurrenceInvolvedModal
      :visible.sync="showInvolvedModal"
      :involveds.sync="pendingInvolveds"
      :discipline-id="form.discipline_id"
      @close="showInvolvedModal = false"
    />

    <!-- Modal de Finalização -->
    <FinalizeOccurrenceModal
      :visible.sync="showFinalizeModal"
      :discipline-id="form.discipline_id"
      @confirm="onFinalizeConfirm"
    />

    <!-- Modal de Interrogatório -->
    <InterrogatoryModal
      v-if="pendingInterrogatory"
      :interrogatory="pendingInterrogatory"
      :visible.sync="showInterrogatoryModal"
      :review-answers="interrReviewAnswers"
      :mandatory="pendingInterrogatoryRequired"
      @confirm="onInterrConfirm"
      @skip="onInterrSkip"
      @close="onInterrogatoryClosed()"
    />

    <!-- Modal de Listagem -->
    <b-modal
      v-model="showListModal"
      title="Ocorrências"
      size="xl"
      scrollable
      ok-only
      ok-title="Fechar"
      @show="onListModalShow"
    >
      <div
        class="d-flex flex-wrap align-items-end mb-1"
        style="gap: 10px"
      >
        <div style="min-width: 150px">
          <label
            class="d-block mb-25"
            style="font-size: 12px"
          >Situação</label>
          <select
            v-model="filters.status"
            class="form-control form-control-sm"
          >
            <option value="">
              Todas
            </option>
            <option value="1">
              Abertas
            </option>
            <option value="2">
              Finalizadas
            </option>
            <option value="0">
              Rascunhos
            </option>
          </select>
        </div>
        <div style="min-width: 150px">
          <label
            class="d-block mb-25"
            style="font-size: 12px"
          >Protocolo</label>
          <input
            v-model="filters.protocol"
            type="text"
            class="form-control form-control-sm"
            placeholder="2609050001"
            @keyup.enter="fetchOccurrences"
          >
        </div>
        <div style="min-width: 170px">
          <label
            class="d-block mb-25"
            style="font-size: 12px"
          >Disciplina</label>
          <v-select
            v-model="filters.discipline_id"
            :options="disciplines"
            :reduce="(d) => d.id"
            label="name"
            placeholder="Todas"
            class="vselect vselect--sm"
          />
        </div>
        <div style="min-width: 170px">
          <label
            class="d-block mb-25"
            style="font-size: 12px"
          >Tipo</label>
          <v-select
            v-model="filters.dispatch_type_id"
            :options="dispatchTypes"
            :reduce="(d) => d.id"
            label="name"
            placeholder="Todos"
            class="vselect vselect--sm"
          />
        </div>
        <div style="min-width: 130px">
          <label
            class="d-block mb-25"
            style="font-size: 12px"
          >De</label>
          <input
            v-model="filters.date_from"
            type="date"
            class="form-control form-control-sm"
          >
        </div>
        <div style="min-width: 130px">
          <label
            class="d-block mb-25"
            style="font-size: 12px"
          >Até</label>
          <input
            v-model="filters.date_to"
            type="date"
            class="form-control form-control-sm"
          >
        </div>
        <button
          class="btn btn-sm btn-primary"
          @click="fetchOccurrences"
        >
          <i class="fa fa-search" /> Buscar
        </button>
        <button
          class="btn btn-sm btn-outline-secondary"
          @click="limparFiltros"
        >
          Limpar
        </button>
      </div>

      <div class="d-flex align-items-center justify-content-between mb-50">
        <small class="text-muted">
          {{ pagination.total }} ocorrência(s)
        </small>
        <button
          class="btn btn-sm btn-link p-0"
          @click="alternarOrdem"
        >
          {{ listSort === 'desc' ? 'Mais recentes primeiro' : 'Mais antigas primeiro' }}
          <i :class="listSort === 'desc' ? 'fa fa-arrow-down' : 'fa fa-arrow-up'" />
        </button>
      </div>

      <div class="table-responsive">
        <table class="table table-sm table-hover occ-list">
          <thead>
            <tr>
              <th>Protocolo</th>
              <th>Solicitante</th>
              <th>Endereço</th>
              <th>Tipo / Motivo</th>
              <th>Situação</th>
              <th>Aberta em</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="occurrences.length === 0">
              <td
                colspan="6"
                class="text-center text-muted py-3"
              >
                Nenhuma ocorrência encontrada.
              </td>
            </tr>
            <template v-for="item in linhasAgrupadas">
              <tr
                v-if="item.tipo === 'dia'"
                :key="item.chave"
                class="occ-list__day"
              >
                <td colspan="6">
                  {{ item.rotulo }}
                </td>
              </tr>
              <tr
                v-else
                :key="item.chave"
                :class="{ 'occ-list__row--clickable': podeAbrir(item.occ) }"
                @click="abrirOcorrencia(item.occ)"
              >
                <td>
                  <span
                    class="badge badge-secondary text-monospace"
                    style="font-size: 0.82em; letter-spacing: 0.5px"
                  >{{ item.occ.protocol || "#" + item.occ.id }}</span>
                </td>
                <td>{{ item.occ.requester_name || "—" }}</td>
                <td>{{ item.occ.address || "—" }}</td>
                <td>
                  <div>{{ item.occ.dispatch_type ? item.occ.dispatch_type.name : "—" }}</div>
                  <small class="text-muted">
                    {{ item.occ.dispatch_reason ? item.occ.dispatch_reason.name : "sem motivo" }}
                    <template v-if="item.occ.discipline">
                      · {{ item.occ.discipline.name }}
                    </template>
                  </small>
                </td>
                <td>
                  <span :class="situacao(item.occ).classe">{{ situacao(item.occ).rotulo }}</span>
                </td>
                <td style="white-space: nowrap">
                  <div>{{ horaCurta(item.occ.created_at) }}</div>
                  <small :class="duracao(item.occ).classe">{{ duracao(item.occ).texto }}</small>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <div
        v-if="pagination.last_page > 1"
        class="d-flex justify-content-end mt-2"
      >
        <pagination
          :options="opcoesPaginacao"
          v-model="pagination.current_page"
          :records="pagination.total"
          :per-page="pagination.per_page"
          @paginate="fetchOccurrences"
        />
      </div>
    </b-modal>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { BModal } from 'bootstrap-vue'
import Pagination from 'vue-pagination-2'
import opcoesPaginacao from '@/libs/paginationOptions'
import InterrogatoryModal from '@/components/InterrogatoryModal.vue'
import OccurrenceInvolvedModal from '@/components/involved/OccurrenceInvolvedModal.vue'
import FinalizeOccurrenceModal from '@/components/FinalizeOccurrenceModal.vue'
import ElapsedTimeMixin from '@/mixins/ElapsedTimeMixin'
import ApiErrorMixin from '@/mixins/ApiErrorMixin'

export default {
  name: 'OccurrenceIndex',
  components: {
    vSelect,
    BModal,
    Pagination,
    InterrogatoryModal,
    OccurrenceInvolvedModal,
    FinalizeOccurrenceModal,
  },

  filters: {
    date(value) {
      if (!value) return '-'
      return new Date(value).toLocaleString('pt-BR')
    },
  },
  mixins: [ElapsedTimeMixin, ApiErrorMixin],

  data() {
    return {
      form: {
        requester_name: '',
        requester_phone: '',
        address: '',
        number: '',
        neighborhood: '',
        city: '',
        state: '',
        complement: '',
        zip_code: '',
        latitude: null,
        longitude: null,
        dispatch_type_id: null,
        dispatch_reason_id: null,
        discipline_id: null,
        complaint: '',
      },
      mapCenter: { lat: -15.77972, lng: -47.92972 },
      mapOccurrences: [],
      markerIcon: {
        url: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png',
        scaledSize: { width: 48, height: 48 },
        anchor: { x: 24, y: 48 },
      },
      showInfoWindow: false,
      infoWindowPos: null,
      selectedMapOcc: null,
      dispatchTypes: [],
      dispatchReasons: [],
      disciplines: [],
      showListModal: false,
      occurrences: [],
      filters: {
        discipline_id: null,
        dispatch_type_id: null,
        date_from: '',
        date_to: '',
        status: '',
        protocol: '',
      },
      listSort: 'desc',
      pagination: {
        current_page: 1,
        last_page: 1,
        per_page: 20,
        total: 0,
      },
      pendingInterrogatory: null,
      pendingInterrogatoryRequired: false,
      showInterrogatoryModal: false,
      pendingInterrAnswers: null,
      interrReviewAnswers: [],
      pendingInvolveds: [],
      showInvolvedModal: false,
      currentOccurrenceId: null,
      currentProtocol: '',
      creatingOccurrence: false,
      phoneCreateError: false,
      showFinalizeModal: false,
      currentOccurrenceCreatedAt: null,
      errors: {},
    }
  },

  computed: {
    opcoesPaginacao() {
      return opcoesPaginacao
    },

    linhasAgrupadas() {
      const saida = []
      let diaAtual = null

      this.occurrences.forEach(occ => {
        const dia = (occ.created_at || '').slice(0, 10)

        if (dia !== diaAtual) {
          diaAtual = dia
          saida.push({
            tipo: 'dia',
            chave: `dia-${dia}`,
            rotulo: this.diaLongo(occ.created_at),
          })
        }

        saida.push({ tipo: 'linha', chave: `occ-${occ.id}`, occ })
      })

      return saida
    },
  },

  mounted() {
    document.documentElement.style.overflow = 'hidden'
    this.loadInitialData()
    this.checkDraft()
  },

  beforeDestroy() {
    document.documentElement.style.overflow = ''
  },

  methods: {
    loadInitialData() {
      const self = this
      const { api } = self.$store.state
      const selectedNode = self.$store.state.selected_node

      // Disciplinas ativas (globais, sem filtro de nó)
      axios
        .get(`${api}discipline?paginated=false&status=1`)
        .then(r => (self.disciplines = r.data.data))
        .catch(() => {})

      // Pins do mapa
      self.loadMapData()
    },

    getMarkerIcon(occ) {
      const url = (occ && (occ.dispatch_type_pin_url || occ.discipline_pin_url))
        || 'https://maps.google.com/mapfiles/ms/icons/red-dot.png'
      return {
        url,
        scaledSize: { width: 48, height: 48 },
        anchor: { x: 24, y: 48 },
      }
    },

    timeAgo(dateStr) {
      if (!dateStr) return ''
      const diff = Math.floor(
        (Date.now() - new Date(dateStr).getTime()) / 1000,
      )
      if (diff < 60) return 'agora'
      if (diff < 3600) {
        const m = Math.floor(diff / 60)
        return `há ${m} min`
      }
      if (diff < 86400) {
        const h = Math.floor(diff / 3600)
        return `há ${h}h`
      }
      const d = Math.floor(diff / 86400)
      return `há ${d} dia${d > 1 ? 's' : ''}`
    },

    loadMapData() {
      const self = this
      axios
        .get(`${self.$store.state.api}occurrences/map-data`)
        .then(r => {
          self.mapOccurrences = r.data.data
          // Centraliza no primeiro pin se existir
          if (self.mapOccurrences.length > 0) {
            self.mapCenter = {
              lat: self.mapOccurrences[0].latitude,
              lng: self.mapOccurrences[0].longitude,
            }
          }
        })
        .catch(() => {})
    },

    onDisciplineChange(disciplineId) {
      this.form.dispatch_type_id = null
      this.form.dispatch_reason_id = null
      this.dispatchTypes = []
      this.dispatchReasons = []
      if (!disciplineId) return
      axios
        .get(
          `${this.$store.state.api
          }dispatch_types?paginated=false&status=1&discipline_id=${
            disciplineId}`,
        )
        .then(r => (this.dispatchTypes = r.data.data))
        .catch(() => {})
    },

    onTypeChange(typeId) {
      this.form.dispatch_reason_id = null
      this.dispatchReasons = []
      this.pendingInterrogatory = null
      this.pendingInterrogatoryRequired = false
      this.pendingInterrAnswers = null
      this.interrReviewAnswers = []
      if (!typeId) return
      axios
        .get(
          `${this.$store.state.api
          }dispatch_reasons?paginated=false&dispatch_type_id=${
            typeId}`,
        )
        .then(r => (this.dispatchReasons = r.data.data))
        .catch(() => {})
    },

    onReasonChange(reasonId) {
      this.pendingInterrogatory = null
      this.pendingInterrogatoryRequired = false
      this.pendingInterrAnswers = null
      this.interrReviewAnswers = []
      if (!reasonId) return

      const reason = this.dispatchReasons.find(r => r.id === reasonId)
      if (reason && reason.interrogatory_id) {
        this.pendingInterrogatoryRequired = !!reason.interrogatory_required
        axios
          .get(
            `${this.$store.state.api
            }interrogatories/${reason.interrogatory_id}?with[]=questions.alternatives`,
          )
          .then(r => {
            this.pendingInterrogatory = r.data.data[0]
            this.showInterrogatoryModal = true
          })
          .catch(() => {})
      }
    },

    onPlaceChanged(place) {
      if (!place || !place.geometry) return

      const loc = place.geometry.location
      this.form.latitude = loc.lat()
      this.form.longitude = loc.lng()

      // Centraliza o mapa na localização
      this.mapCenter = { lat: loc.lat(), lng: loc.lng() }

      // Extrai componentes de endereço
      const components = place.address_components || []
      const get = type => {
        const c = components.find(c => c.types.includes(type))
        return c ? c.long_name : ''
      }
      const getShort = type => {
        const c = components.find(c => c.types.includes(type))
        return c ? c.short_name : ''
      }

      this.form.address = (get('route') || '')
        + (get('street_number') ? `, ${get('street_number')}` : '')
      this.form.neighborhood = get('sublocality_level_1') || get('sublocality') || get('neighborhood')
      this.form.city = get('administrative_area_level_2') || get('locality')
      this.form.state = getShort('administrative_area_level_1')
      this.form.zip_code = get('postal_code')
      this.form.number = get('street_number')
    },

    onMapClick(event) {
      const lat = event.latLng.lat()
      const lng = event.latLng.lng()
      this.form.latitude = lat.toFixed(7)
      this.form.longitude = lng.toFixed(7)

      // Reverse geocoding
      if (window.google && window.google.maps) {
        const geocoder = new window.google.maps.Geocoder()
        geocoder.geocode({ location: { lat, lng } }, (results, status) => {
          if (status === 'OK' && results[0]) {
            const place = results[0]
            const input = this.$refs.autocomplete
            // Atualiza o campo de texto do autocomplete
            if (input && input.$refs && input.$refs.input) {
              input.$refs.input.value = place.formatted_address
            }
            this.onPlaceChanged(place)
          }
        })
      }
    },

    onMarkerDrag(event) {
      this.form.latitude = event.latLng.lat().toFixed(7)
      this.form.longitude = event.latLng.lng().toFixed(7)
    },

    onInterrConfirm(payload) {
      this.pendingInterrAnswers = payload
      this.interrReviewAnswers = payload.answers || []
      this.showInterrogatoryModal = false
    },

    onInterrSkip() {
      this.pendingInterrAnswers = null
      this.interrReviewAnswers = []
      this.pendingInterrogatory = null
      this.pendingInterrogatoryRequired = false
      this.showInterrogatoryModal = false
    },

    /**
     * Roda no `close` do modal, que o InterrogatoryModal emite a partir do
     * `hidden` da BootstrapVue — depois de ela devolver o foco. E o unico
     * instante em que fechar o select resolve: antes disso o foco ainda
     * voltaria para ele, e o vue-select abre a lista em qualquer evento de
     * foco (`onSearchFocus` faz `open = true`).
     */
    onInterrogatoryClosed() {
      this.showInterrogatoryModal = false

      const select = this.$refs.reasonSelect
      if (!select) return

      if (select.searchEl) select.searchEl.blur()
      if (typeof select.closeSearchOptions === 'function') {
        select.closeSearchOptions()
      }
    },

    openInterrReview() {
      this.showInterrogatoryModal = true
    },

    onPhoneBlur() {
      const phone = this.form.requester_phone.replace(/\D/g, '')
      if (
        phone.length < 10
        || this.currentOccurrenceId
        || this.creatingOccurrence
      ) return
      this.phoneCreateError = false
      this.creatingOccurrence = true
      axios
        .post(`${this.$store.state.api}occurrences`, {
          requester_phone: this.form.requester_phone,
          status: 0,
        })
        .then(r => {
          const occurrence = r.data.data || r.data
          this.currentOccurrenceId = occurrence.id
          this.currentProtocol = occurrence.protocol || ''
          this.currentOccurrenceCreatedAt = occurrence.created_at || null
          this.loadMapData()
        })
        .catch(() => {
          this.phoneCreateError = true
        })
        .finally(() => {
          this.creatingOccurrence = false
        })
    },

    retryOpenOccurrence() {
      this.phoneCreateError = false
      this.onPhoneBlur()
    },

    checkDraft() {
      axios
        .get(`${this.$store.state.api}occurrences/my-draft`)
        .then(r => {
          const occ = r.data.data
          if (!occ) return
          this.currentOccurrenceId = occ.id
          this.currentProtocol = occ.protocol || ''
          this.currentOccurrenceCreatedAt = occ.created_at || null
          const fields = [
            'requester_phone',
            'requester_name',
            'address',
            'number',
            'neighborhood',
            'city',
            'state',
            'complement',
            'zip_code',
            'latitude',
            'longitude',
            'dispatch_type_id',
            'dispatch_reason_id',
            'discipline_id',
            'complaint',
          ]
          fields.forEach(f => {
            if (occ[f] !== null && occ[f] !== undefined) this.form[f] = occ[f]
          })
          const { api } = this.$store.state
          if (occ.discipline_id) {
            axios
              .get(
                `${api
                }dispatch_types?paginated=false&status=1&discipline_id=${
                  occ.discipline_id}`,
              )
              .then(r => {
                this.dispatchTypes = r.data.data
              })
          }
          if (occ.dispatch_type_id) {
            axios
              .get(
                `${api
                }dispatch_reasons?paginated=false&dispatch_type_id=${
                  occ.dispatch_type_id}`,
              )
              .then(r => {
                this.dispatchReasons = r.data.data
              })
          }
          this.$nextTick(() => {
            if (this.$refs.autocomplete?.$refs?.input) {
              this.$refs.autocomplete.$refs.input.value = occ.address || ''
            }
          })
        })
        .catch(() => {})
    },

    onFinalizeConfirm(payload) {
      const self = this
      self.$loading(true)
      axios
        .post(
          `${self.$store.state.api
          }occurrences/${
            self.currentOccurrenceId
          }/finalize`,
          payload,
        )
        .then(() => {
          self.$message(
            'Sucesso',
            'Ocorrência finalizada com sucesso.',
            'success',
          )
          self.showFinalizeModal = false
          self.resetForm()
          self.loadMapData()
        })
        .catch(e => self.$message(
          'Erro',
          self.apiErrorText(e, 'Erro ao finalizar.'),
          'error',
        ))
        .finally(() => self.$loading(false))
    },

    save() {
      const self = this
      const e = {}
      if (!self.form.requester_name) e.requester_name = true
      if (!self.form.requester_phone) e.requester_phone = true
      if (!self.form.address) e.address = true
      if (!self.form.complaint) e.complaint = true
      if (!self.form.discipline_id) e.discipline_id = true
      if (!self.form.dispatch_type_id) e.dispatch_type_id = true
      self.errors = e
      if (Object.keys(e).length > 0) {
        self.$message(
          'Atenção',
          'Preencha todos os campos obrigatórios.',
          'error',
        )
        return
      }

      if (
        self.pendingInterrogatory
        && self.pendingInterrogatoryRequired
        && !self.pendingInterrAnswers
      ) {
        self.$message(
          'Interrogatório obrigatório',
          'Responda o interrogatório antes de encaminhar a ocorrência.',
          'error',
        )
        self.showInterrogatoryModal = true
        return
      }

      self.$loading(true)
      const saveRequest = self.currentOccurrenceId
        ? axios.put(
          `${self.$store.state.api}occurrences/${self.currentOccurrenceId}`,
          { ...self.form },
        )
        : axios.post(`${self.$store.state.api}occurrences`, self.form)

      saveRequest
        .then(r => {
          const occurrence = r.data.data || r.data
          const occurrenceId = occurrence.id || self.currentOccurrenceId

          // Avança o step no pipeline (solicita → próximo → ... → despacha)
          return axios
            .post(
              `${self.$store.state.api
              }occurrences/${
                occurrenceId
              }/forward`,
            )
            .then(() => {
              const protocol = occurrence.protocol || self.currentProtocol || ''
              return { occurrenceId, protocol }
            })
        })
        .then(({ occurrenceId, protocol }) => {
          const successMsg = protocol
            ? `Ocorrência encaminhada com sucesso.<br><strong>Protocolo: ${protocol}</strong>`
            : 'Ocorrência encaminhada com sucesso.'

          // Encadeia o salvamento do interrogatório (se houver) e dos envolvidos
          let chain = Promise.resolve()

          if (self.pendingInterrAnswers && self.pendingInterrogatory) {
            chain = chain.then(() => axios
              .post(`${self.$store.state.api}occurrence_interrogatories`, {
                occurrence_id: occurrenceId,
                interrogatory_id: self.pendingInterrogatory.id,
                answers: self.pendingInterrAnswers.answers,
              })
              .catch(() => {
                self.$message(
                  'Sucesso',
                  `${successMsg}<br>Falha ao salvar interrogatório.`,
                  'warning',
                )
              }))
          }

          if (self.pendingInvolveds.length > 0) {
            chain = chain.then(() => {
              const involvedPromises = self.pendingInvolveds.map(inv => {
                const payload = {
                  occurrence_id: occurrenceId,
                  entity_type: inv.entity_type,
                  involved_role_id: inv.involved_role_id,
                }
                if (inv.entity_id) {
                  payload.entity_id = inv.entity_id
                } else {
                  payload.entity = inv.entity
                }
                return axios.post(
                  `${self.$store.state.api}occurrence_involveds`,
                  payload,
                )
              })
              return Promise.allSettled(involvedPromises).then(results => {
                const failed = results.filter(
                  r => r.status === 'rejected',
                ).length
                if (failed > 0) {
                  self.$message(
                    'Sucesso',
                    `${successMsg}<br>${failed} envolvido(s) não puderam ser salvos.`,
                    'warning',
                  )
                }
              })
            })
          }

          return chain.then(() => {
            self.$message('Sucesso', successMsg, 'success')
          })
        })
        .then(() => {
          self.resetForm()
          self.loadMapData()
        })
        .catch(err => {
          self.$message(
            null,
            err.response?.data || 'Erro ao encaminhar.',
            'error',
          )
        })
        .finally(() => self.$loading(false))
    },

    resetForm() {
      this.form = {
        requester_name: '',
        requester_phone: '',
        address: '',
        number: '',
        neighborhood: '',
        city: '',
        state: '',
        complement: '',
        zip_code: '',
        latitude: null,
        longitude: null,
        dispatch_type_id: null,
        dispatch_reason_id: null,
        discipline_id: null,
        complaint: '',
      }
      this.dispatchReasons = []
      this.pendingInterrogatory = null
      this.pendingInterrogatoryRequired = false
      this.pendingInterrAnswers = null
      this.interrReviewAnswers = []
      this.pendingInvolveds = []
      this.currentOccurrenceId = null
      this.currentProtocol = ''
      this.currentOccurrenceCreatedAt = null
      this.creatingOccurrence = false
      this.phoneCreateError = false
      this.showFinalizeModal = false
      this.errors = {}
      if (
        this.$refs.autocomplete
        && this.$refs.autocomplete.$refs
        && this.$refs.autocomplete.$refs.input
      ) {
        this.$refs.autocomplete.$refs.input.value = ''
      }
    },

    onListModalShow() {
      this.pagination.current_page = 1
      this.occurrences = []
      this.fetchOccurrences()
    },

    limparFiltros() {
      this.filters = {
        discipline_id: null,
        dispatch_type_id: null,
        date_from: '',
        date_to: '',
        status: '',
        protocol: '',
      }
      this.fetchOccurrences()
    },

    alternarOrdem() {
      this.listSort = this.listSort === 'desc' ? 'asc' : 'desc'
      this.fetchOccurrences()
    },

    situacao(occ) {
      const st = Number(occ.status)

      if (st === 1) return { rotulo: 'Aberta', classe: 'badge badge-success' }
      if (st === 2) return { rotulo: 'Finalizada', classe: 'badge badge-primary' }

      return { rotulo: 'Rascunho', classe: 'badge badge-light border' }
    },

    duracao(occ) {
      if (!occ.created_at) return { texto: '—', classe: 'text-muted' }

      const inicio = new Date(occ.created_at).getTime()
      const aberta = Number(occ.status) === 1
      let fim = null

      if (aberta) {
        fim = this.elapsedNow
      } else if (occ.finalized_at) {
        fim = new Date(occ.finalized_at).getTime()
      }

      if (fim === null) return { texto: '—', classe: 'text-muted' }

      const texto = this.duracaoLonga(Math.max(0, Math.floor((fim - inicio) / 1000)))

      if (!aberta) return { texto, classe: 'text-muted' }

      const horas = (fim - inicio) / 3600000
      if (horas >= 24) return { texto: `aberta há ${texto}`, classe: 'text-danger' }
      if (horas >= 4) return { texto: `aberta há ${texto}`, classe: 'text-warning' }

      return { texto: `aberta há ${texto}`, classe: 'text-muted' }
    },

    duracaoLonga(segundos) {
      const dias = Math.floor(segundos / 86400)
      const horas = Math.floor((segundos % 86400) / 3600)
      const min = Math.floor((segundos % 3600) / 60)

      if (dias > 0) {
        return dias + (dias === 1 ? ' dia' : ' dias') + (horas ? ` ${horas}h` : '')
      }
      if (horas > 0) return `${horas}h${min ? ` ${min}min` : ''}`

      return `${min}min`
    },

    horaCurta(iso) {
      if (!iso) return '—'
      return new Date(iso).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
    },

    diaLongo(iso) {
      if (!iso) return 'sem data'
      return new Date(iso).toLocaleDateString('pt-BR', {
        weekday: 'long',
        day: '2-digit',
        month: 'long',
        year: 'numeric',
      })
    },

    podeAbrir(occ) {
      return occ.current_step === 'regula' || occ.current_step === 'despacha'
    },

    abrirOcorrencia(occ) {
      if (!this.podeAbrir(occ)) return

      const nome = occ.current_step === 'regula' ? 'regulacao-detail' : 'despacho-detail'
      this.$router.push({ name: nome, params: { id: occ.id } })
    },

    fetchOccurrences() {
      const self = this
      const { api } = self.$store.state
      const params = new URLSearchParams({
        paginated: true,
        page: self.pagination.current_page,
        per_page: self.pagination.per_page,
        context: 'ocorrencia',
      })

      params.append('with[]', 'dispatchType')
      params.append('with[]', 'dispatchReason')
      params.append('with[]', 'discipline')

      if (self.filters.discipline_id) params.append('discipline_id', self.filters.discipline_id)
      if (self.filters.dispatch_type_id) params.append('dispatch_type_id', self.filters.dispatch_type_id)
      if (self.filters.date_from) params.append('date_from', self.filters.date_from)
      if (self.filters.date_to) params.append('date_to', self.filters.date_to)
      if (self.filters.status !== '') params.append('status', self.filters.status)
      if (self.filters.protocol) params.append('protocol', self.filters.protocol.trim())

      params.append(
        self.listSort === 'desc' ? 'orderByDesc' : 'orderByAsc',
        'created_at',
      )

      self.$loading(true)
      axios
        .get(`${api}occurrences?${params.toString()}`)
        .then(r => {
          const { data } = r.data
          if (data.data) {
            self.occurrences = data.data
            self.pagination.total = data.total
            self.pagination.per_page = data.per_page
            self.pagination.last_page = data.last_page
            self.pagination.current_page = data.current_page
          } else {
            self.occurrences = data
          }
        })
        .catch(() => {})
        .finally(() => self.$loading(false))
    },
  },
}
</script>

<style scoped>
.occ-list__day td {
  background: #f6f7fb;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #6b7280;
  padding-top: 6px;
  padding-bottom: 6px;
}

.dark-layout .occ-list__day td {
  background: #232a3d;
  color: #b4b7bd;
}

.occ-list__row--clickable {
  cursor: pointer;
}

.occ-list td {
  vertical-align: middle;
}

.vselect--sm ::v-deep .vs__dropdown-toggle {
  min-height: 31px;
  padding-top: 0;
  padding-bottom: 0;
}

.occurrence-page {
  position: relative;
  width: 100%;
  /*
   * 100vh minus:
   *   navbar + content-padding-top + floating-nav-margin = 7.75rem
   *   breadcrumb row                                     = ~3.4rem
   *   footer                                             = 3.35rem
   *   Total                                              ~ 14.5rem → 15rem safe
   */
  height: calc(100vh - 15rem);
  overflow: hidden;
  border-radius: 0.428rem;
}

.occ-panel {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 380px;
  background: #fff;
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.18);
  display: flex;
  flex-direction: column;
  z-index: 1;
  overflow: hidden;
}

.occ-panel__header {
  padding: 16px 20px 10px;
  border-bottom: 1px solid #eee;
  background: #fff;
}

.occ-panel__title {
  display: inline-flex;
  align-items: center;
  font-size: 1rem;
  font-weight: 600;
}

.occ-panel__title--creating {
  color: #aaa;
}

.occ-panel__title--open {
  color: #e07b00;
}

.occ-open-error {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff0f0;
  border-left: 3px solid #dc3545;
  border-radius: 6px;
  padding: 6px 10px;
  width: 100%;
}

.occ-open-error__msg {
  display: inline-flex;
  align-items: center;
  font-size: 0.82rem;
  font-weight: 600;
  color: #dc3545;
}

.occ-open-error__retry {
  background: none;
  border: 1px solid #dc3545;
  border-radius: 5px;
  color: #dc3545;
  font-size: 0.78rem;
  font-weight: 600;
  padding: 3px 10px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  transition: background 0.15s;
}

.occ-open-error__retry:hover {
  background: rgba(220, 53, 69, 0.08);
}

.occ-panel__body {
  flex: 1;
  overflow-y: auto;
  padding: 14px 20px;
}

/* Botão flutuante centralizado na base do mapa */
.occ-list-fab {
  position: absolute;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  padding: 10px 28px;
  background: #fff;
  border: 1px solid #d8d6de;
  border-radius: 50px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);
  font-size: 0.95rem;
  cursor: pointer;
  white-space: nowrap;
  transition: box-shadow 0.2s;
}

.occ-list-fab:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.28);
}

.required {
  color: #dc3545;
}

.is-invalid-vselect :deep(.vs__dropdown-toggle) {
  border-color: #dc3545;
}

/* Garante que o input do GmapAutocomplete herde o estilo do Bootstrap */
:deep(.pac-target-input) {
  width: 100%;
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
  padding: 0.438rem 1rem;
  font-size: 1rem;
  line-height: 1.45;
  color: #6e6b7b;
  background-color: #fff;
  background-clip: padding-box;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  outline: none;
}

:deep(.pac-target-input:focus) {
  border-color: #7367f0;
  box-shadow: 0 3px 10px 0 rgba(34, 41, 47, 0.1);
}

.interr-done-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #e7faf0;
  border-left: 3px solid #28c76f;
  border-radius: 6px;
  padding: 7px 12px;
  font-size: 0.85rem;
}

.interr-done-label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-weight: 600;
  color: #28c76f;
  white-space: nowrap;
}

.interr-done-btn {
  background: none;
  border: 1px solid #28c76f;
  border-radius: 5px;
  color: #28c76f;
  font-size: 0.78rem;
  font-weight: 600;
  padding: 3px 10px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 3px;
  transition: background 0.15s;
  white-space: nowrap;
}

.interr-done-btn:hover {
  background: rgba(40, 199, 111, 0.1);
}
</style>
